// de_pms_reports.ts
// Übersetzungen für PMS.Reports – Live-Betriebsberichts-Snapshot

export const dePmsReports = {

  title: "Berichte",
  subtitle: "Live-Snapshot der operativen Berichte aus dem Ops-PMS-Backend.",

  // ── Kennzahlen ────────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Auslastung",
    reservations:     "Reservierungen",
    checkedIn:        "Eingecheckt",
    checkedOut:       "Ausgecheckt",
    currentProperty:  "Aktuelles Hotel",
    liveStatus:       "Live-Status",
  },

  // ── Primärtabelle ─────────────────────────────────────────────────────────
  primary: {
    title:              "Operative Performance",
    subtitle:           "Aktuelle Hotelaktivitaet aus dem Ops-PMS-Berichts-Snapshot.",
    arrivalsToday:      "Ankünfte heute",
    departuresToday:    "Abreisen heute",
    totalCharges:       "Gesamtbelastungen",
    totalPayments:      "Gesamtzahlungen",
    outstandingBalance: "Offener Saldo",
  },

  // ── Marktsegment-Tabelle ──────────────────────────────────────────────────
  marketSegment: {
    title:            "Marktsegment-Mix",
    subtitle:         "Live-Reservierungsmix nach Marktsegment aus dem Ops PMS Backend.",
    emptyLabel:       "Marktsegmente",
    emptyValue:       "0 Live-Marktsegment-Einträge",
    reservationCount: "{{count}} Reservierung(en)",
  },

  // ── Quellen & Pickup-Tabelle ──────────────────────────────────────────────
  sourcePickup: {
    title:              "Quellen-Performance",
    subtitle:           "Live-Reservierungsproduktion nach Quelle/Kanal aus dem Ops-PMS-Backend.",
    emptySourceLabel:   "Quellenproduktion",
    emptySourceValue:   "0 Live-Quellen-/Kanaleinträge",
    reservationCount:   "{{count}} Reservierung(en)",
  },

  pickup: {
    title:      "Pickup (7d)",
    subtitle:   "Pro Tag erstellte Buchungen in den letzten 7 Tagen.",
    emptyValue: "0 Live-Pickup-Zeilen",
  },

  meta: {
    generatedAt: "Snapshot erstellt",
  },

} as const;

export default dePmsReports;
